import { theme } from "@common/theme/theme"

// OTA fallback only. The backend is the source of truth via
// live_room.supports_no_show_recovery (LiveRoom::RECOVERABLE_TYPES). This list
// is used solely when a new app build talks to a backend that predates the
// flag; it must therefore mirror RECOVERABLE_TYPES, summer holiday_workbook
// included.
const NO_SHOW_RECOVERY_FALLBACK_TYPES = ["biweekly", "study_group", "holiday_workbook"]

/**
 * Whether a live room is eligible for the tutor no-show / absence-recovery flow.
 * Reads the backend capability flag, falling back to the room type only for old
 * backends that don't send it yet. Keeps the room-type policy on the backend so
 * new group types (e.g. summer sessions) work without a frontend release.
 */
export const supportsNoShowRecovery = (liveRoom) =>
    liveRoom?.supports_no_show_recovery ??
    NO_SHOW_RECOVERY_FALLBACK_TYPES.includes(liveRoom?.type)

export const getLiveSessionTypeMeta = (type) => {
    switch (type) {
        case "individual":
            return {
                label: "Individuel",
                color: theme.colors.accentDark,
                backgroundColor: theme.colors.accentLighter,
            }
        case "biweekly":
            return {
                label: "Cours partagé",
                color: theme.colors.primary,
                backgroundColor: theme.colors.primaryLighter,
            }
        case "study_group":
            return {
                label: "Étude encadrée",
                color: theme.colors.primary,
                backgroundColor: theme.colors.primaryLighter,
            }
        case "trial":
            return {
                label: "Essai",
                color: theme.colors.warning,
                backgroundColor: theme.colors.warningLight,
            }
        case "holiday_course":
            return {
                label: "Stage",
                color: theme.colors.purple,
                backgroundColor: theme.colors.purpleLight,
            }
        case "support":
            return {
                label: "Support",
                color: theme.colors.info,
                backgroundColor: theme.colors.infoLight,
            }
        case "custom":
            return {
                label: "Tutoriel",
                color: theme.colors.brown,
                backgroundColor: theme.colors.brownLight,
            }
        case "holiday_workbook":
            return {
                label: "Cours d'été",
                color: theme.colors.error,
                backgroundColor: theme.colors.errorLight,
            }
        default:
            return {
                label: "Autre",
                color: theme.colors.grey,
                backgroundColor: theme.colors.lighter,
            }
    }
}
